import { render, staticRenderFns } from "./point_order.vue?vue&type=template&id=4b6758b8&scoped=true"
import script from "./point_order.vue?vue&type=script&lang=js"
export * from "./point_order.vue?vue&type=script&lang=js"
import style0 from "./point_order.vue?vue&type=style&index=0&id=4b6758b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6758b8",
  null
  
)

export default component.exports